import React, { useState,useEffect  } from 'react';
import "./AdminHome.css";
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Sidebar from '../../../components/Sidebar/Sidebar';
const AdminHome = () => {
    const navigate = useNavigate();

    // Add your components here for the admin home page. Remember to use the Sidebar and NavigationBar components.
    return (
        <>
        <head><title>Verwaltung || Home</title></head>
        <NavigationBar state="adminhome" back="inline"/>
        
        <Sidebar/>
        </>
 );



}
export default AdminHome;